import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.timers.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mapGetters } from 'vuex';
export default {
  name: 'JobFilters',
  props: {
    clearingFilters: {
      default: false,
      required: false,
      type: Boolean
    }
  },
  setup: function setup() {
    var job_industries = reactive([]);
    var showFilters = ref(false);
    var filters = ref({
      job_type: null,
      location_type: null
    });
    var job_types = ref([{
      value: 'full-time',
      text: 'Full Time'
    }, {
      value: 'part-time',
      text: 'Part Time'
    }, {
      value: 'fixed-term',
      text: 'Fixed Term'
    }, {
      value: 'internship',
      text: 'Internship'
    }]);
    var location_types = ref([{
      value: 'remote',
      text: 'Remote'
    }, {
      value: 'in-person',
      text: 'In Person'
    }, {
      value: 'hybrid',
      text: 'Hybrid'
    }]);
    var slideIn = ref(false);
    var loadingClear = ref(false);
    var loadingFilters = ref(false);
    return {
      filters: filters,
      job_types: job_types,
      location_types: location_types,
      slideIn: slideIn,
      loadingClear: loadingClear,
      loadingFilters: loadingFilters,
      job_industries: job_industries,
      showFilters: showFilters
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters('jobs', {
    currentFilters: 'getFilters',
    currentIndustryFilters: 'getIndustryFilters'
  })), mapGetters('global/dropdown', {
    industries: 'getIndustries',
    fieldsOfInterest: 'getFieldsOfInterest'
  })), {}, {
    filterIndustries: function filterIndustries() {
      var _this$job_industries;

      return (_this$job_industries = this.job_industries) === null || _this$job_industries === void 0 ? void 0 : _this$job_industries.map(function (item) {
        return item.industry ? item.industry.name : null;
      }).filter(function (item) {
        return item !== null;
      });
    },
    filterInterests: function filterInterests() {
      if (!this.job_industries) return [];
      return this.job_industries.filter(function (object) {
        return object.industry;
      }).flatMap(function (object) {
        return Array.isArray(object.fields_of_interest) ? object.fields_of_interest.map(function (item) {
          return item.name;
        }) : [];
      });
    }
  }),
  watch: {
    slideIn: function slideIn(newValue) {
      if (!newValue) {
        this.hideJobFilters();
      }
    },
    currentFilters: function currentFilters() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));

      if (typeof filters.job_type === 'string') {
        filters.job_type = this.job_types.find(function (type) {
          return type.value === filters.job_type;
        });
      }

      if (typeof filters.location_type === 'string') {
        filters.location_type = this.location_types.find(function (type) {
          return type.value === filters.location_type;
        });
      }

      this.filters = filters;
    },
    currentIndustryFilters: function currentIndustryFilters() {
      this.job_industries = JSON.parse(JSON.stringify(this.currentIndustryFilters));
    },
    filterIndustries: function filterIndustries() {
      if (this.filterIndustries && this.filterIndustries.length > 0) {
        this.filters.industries = this.filterIndustries;
      } else {
        this.filters.industries = null;
      }
    },
    filterInterests: function filterInterests() {
      if (this.filterInterests && this.filterInterests.length > 0) {
        this.filters.interests = this.filterInterests;
      } else {
        this.filters.interests = null;
      }
    },
    clearingFilters: function clearingFilters(value) {
      if (value) {
        this.job_industries = [];
      }
    }
  },
  created: function created() {
    this.slide();
    this.getIndustries();

    if (this.currentFilters) {
      this.filters = JSON.parse(JSON.stringify(this.currentFilters));
    }

    if (this.currentIndustryFilters) {
      this.job_industries = JSON.parse(JSON.stringify(this.currentIndustryFilters));
    }
  },
  methods: {
    slide: function slide() {
      var _this = this;

      setTimeout(function () {
        _this.slideIn = !_this.slideIn;
      }, 200);
    },
    hideJobFilters: function hideJobFilters() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$store.dispatch('jobs/setShowJobFilters', false);
      }, 300);
    },
    applyFilters: function applyFilters() {
      var _this3 = this;

      this.loadingFilters = true;
      this.showFilters = false;
      this.$store.dispatch('jobs/setCursor', null);
      this.$store.dispatch('jobs/setFilters', JSON.parse(JSON.stringify(this.filters)));
      this.$store.dispatch('jobs/setIndustryFilters', JSON.parse(JSON.stringify(this.job_industries)));
      this.$store.dispatch('jobs/getFilteredJobs').then(function () {
        _this3.loadingFilters = false;

        _this3.slide();
      }).catch(function (err) {
        _this3.loadingFilters = false;
      });
    },
    clearFilters: function clearFilters() {
      var _this4 = this;

      this.job_industries = [];
      this.filters.job_type = null;
      this.filters.location_type = null;
      this.filters.industries = null;
      this.filters.interests = null;
      this.loadingClear = true;
      this.$store.dispatch('jobs/setCursor', null);
      this.$store.dispatch('jobs/setFilters', JSON.parse(JSON.stringify(this.filters)));
      this.$store.dispatch('jobs/setIndustryFilters', JSON.parse(JSON.stringify(this.job_industries)));
      this.$store.dispatch('jobs/getFilteredJobs').then(function () {
        _this4.loadingClear = false;

        _this4.slide();
      }).catch(function (err) {
        _this4.loadingFilters = false;
      });
    },
    getIndustries: function getIndustries() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.$store.dispatch('global/dropdown/getIndustries');

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearIndustryFilters: function clearIndustryFilters() {
      this.job_industries = [];
      this.showFilters = false;
      this.filters.industries = null;
      this.filters.interests = null;
      this.$store.dispatch('jobs/setFilters', JSON.parse(JSON.stringify(this.filters)));
      this.$store.dispatch('jobs/setIndustryFilters', JSON.parse(JSON.stringify(this.job_industries)));
      this.applyFilters();
    }
  }
};